module.exports = __webpack_public_path__ + "gf.svg?3186e80e532dae0eba767123c3610b40";